import { accessible } from '../helper';

const useAccessibleKeyboardNavigationHandler = (ref, escapeCb) => event => {
  const {
    key
  } = event;
  const {
    navigateToNextChild,
    navigateToPrevChild
  } = accessible(ref.current);
  if (key === 'ArrowDown') navigateToNextChild();
  if (key === 'ArrowUp') navigateToPrevChild();
  if (key === 'Escape' && typeof escapeCb === 'function') escapeCb(event);
};

export default useAccessibleKeyboardNavigationHandler;